import React, { useContext } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PATH_INTRO, PATH_ROOT } from '../../paths';
// import { StandartPage } from '../../design/StandartPage';
// import tryAgain from '../../../assets/try-again.svg';
import { PermissionButton, WhiteButton } from '../NoPermission/styles';
import RootContext from '../../context';

export const TryAgain = () => {
  const { videoParams } = useContext(RootContext);
  if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;

  const underText = <ul style={{ marginLeft: '-20px' }}>
    <li>Allow access to the camera</li>
    <li>Take off anything from your face</li>
    <li>Position yor face in the camera frame</li>
  </ul>;

  const buttons = <>
    <Link to={`${PATH_ROOT}${PATH_INTRO}`}>
      <WhiteButton>
        cancel
      </WhiteButton>
    </Link>
    <PermissionButton>
      TRY AGAIN
    </PermissionButton>
  </>;

  return (
    <>
      try again
    </>
  );
};
/*
      <StandartPage
        image={tryAgain}
        upperText={'Liveness failed'}
        title={'Let’s try that again'}
        underText={underText}
        buttons={buttons}
      />
 */
